import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { getOnboardingStatus } from "../api/hydra";
import type { IOnBoardingStatusResponse, IOnboardingAPIError } from "../constants/pfsContants";

export const onboardingStatusQueryKey = ["onboardingStatus"] as const;

export const useOnboardingStatus = (
	enabled: boolean,
): UseQueryResult<IOnBoardingStatusResponse, IOnboardingAPIError> => {
	return useQuery<IOnBoardingStatusResponse, { status?: number }>({
		queryKey: onboardingStatusQueryKey,
		enabled,
		queryFn: ({ signal }) => getOnboardingStatus(signal),
	});
};
